import { Component, inject, input, output } from '@angular/core';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { DisplayMessage } from '../../sb-model/display-message';
import { ReactionsService } from '../../../../services/chat-message/reactions/reactions.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { REACTION_TRANSLATION } from './translations';
import { ReactionDto } from '../../sb-model/reaction-dto';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { Room } from '../../../../../shared-api/room';
import { SnackbarService } from '../../../../services/snackbar/snackbar.service';
import { MatrixService } from '../../../../services/matrix/matrix.service';
import { ReactionTestIds } from './sb-reaction.test-ids';

@Component({
  selector: 'app-sb-reaction',
  imports: [ReactiveFormsModule, MatIconModule, PickerComponent, NgClass, MatTooltip, MatIconButton],
  templateUrl: './sb-reaction.component.html',
  styleUrl: './sb-reaction.component.scss'
})
/**
 * Diese Komponente ermöglicht das Anzeigen und Verwalten von Reaktionen auf Nachrichten innerhalb eines Matrix-Chats.
 * Nutzer können durch diese Komponente Emojis als Reaktion hinzufügen, entfernen oder die Reaktionsleiste öffnen.
 *
 *
 * Funktionen:
 * - Öffnen und Schließen der Reaktionsleiste für eine bestimmte Nachricht.
 * - Hinzufügen und Entfernen von Reaktionen (Emojis) durch den Nutzer.
 * - Verwaltung des aktuellen Reaktionsstatus über den {@link ReactionsService}.
 *
 * Hierdurch erfüllte AFO`s
 * - A_25395-01 - Matrix Module (Event Annotations and Reactions)
 *   - Fähigkeit zur Verarbeitung und Anzeige.
 *   - Fähigkeit zur Erzeugung.
 * - A_26227-01 - Längenbegrenzung von Annotationen in Reactions
 */
export class SbReactionComponent {
  protected readonly testIds = ReactionTestIds;
  protected readonly reactionService = inject(ReactionsService);
  protected readonly clientService = inject(MatrixService);
  protected readonly snackbarService = inject(SnackbarService);

  message = input<DisplayMessage>();
  room = input<Room>();
  protected toolbarMessageId = output<string>();
  protected readonly TRANSLATIONS = REACTION_TRANSLATION;
  protected isReactionBarOpened = false;

  toggleReactionsBar(event: MouseEvent): void {
    event.stopPropagation();
    this.isReactionBarOpened = !this.isReactionBarOpened;
  }

  async sendReaction(reactionsArray: ReactionDto[], eventId: string | undefined, event: EmojiEvent): Promise<void> {
    if (this.room()) {
      try {
        await this.reactionService.sendReaction(reactionsArray, eventId, event.emoji, this.room());
      } catch (e: any) {
        console.warn(e);
        this.snackbarService.error('Fehler beim Senden der Reaktion');
      }
    }
    this.isReactionBarOpened = false;
    this.toolbarMessageId.emit('');
  }
}
